var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"NavigationalTileStage"}},[_c('h1',[_vm._v(_vm._s(_vm.headingNarrative))]),_c('h2',[_vm._v(_vm._s(_vm.subheadingNarrative))])])}
var staticRenderFns = []

export { render, staticRenderFns }